import { colors } from './colors.theme'

const { blue } = colors

export const stepConnectorTheme = {
  line: {
    borderColor: blue,
  },
  vertical: {
    marginLeft: 21,
  },
  lineVertical: {
    minHeight: 40,
  },
}

export const stepContentTheme = {
  root: {
    borderColor: blue,
    marginLeft: 21,
    paddingLeft: 28,
    paddingRight: 28,
  },
}

export const stepLabelTheme = {
  root: {
    padding: 0,
  },
  label: {
    fontSize: '1.125rem',
    fontWeight: 700,
    '&.Mui-active': {
      fontWeight: 700,
    },
  },
}
